import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/Button';
import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { RichTextInput } from '@startuptools/ui/RichTextInput';
import { useState } from 'react';
import { EMPTY_QUILL_RE } from '@startuptools/common/common';

type Props = {
  onClose: () => void;
  comment: string | null | undefined;
  onSave: (comment: string) => Promise<void>;
  loading: boolean;
};

export const CommentDialogInner = ({ onClose, loading, comment, onSave }: Props) => {
  const [editorContent, setEditorContent] = useState<string>(comment || '');

  const handleConfirm = async () => {
    let comment = editorContent;
    if (comment.length === 0 || EMPTY_QUILL_RE.test(comment)) {
      comment = '';
    }
    await onSave(comment.replaceAll('&nbsp;', ' '));

    onClose();
  };

  return (
    <Stack gap={3} margin={2}>
      <Typography level="h4">{comment ? <Trans id="Edit comment" /> : <Trans id="Add comment" />}</Typography>
      <Typography>
        <Trans id="Write your comment below" />
      </Typography>
      <RichTextInput
        value={editorContent}
        onChange={val => setEditorContent(val ?? '')}
        style={{ minWidth: '800px', maxWidth: '1100px', maxHeight: '1000px' }}
      />
      <Stack direction="row" justifyContent="end" gap={1}>
        <Button onClick={onClose} variant="plain" color="neutral" disabled={loading}>
          <Trans id="Cancel" />
        </Button>
        <Button onClick={handleConfirm} loading={loading}>
          <Trans id="Save" />
        </Button>
      </Stack>
    </Stack>
  );
};

export const CommentDialog = (props: Props) => {
  return (
    <Modal open onClose={props.onClose}>
      <ModalDialog>
        <ModalClose />
        <CommentDialogInner {...props} />
      </ModalDialog>
    </Modal>
  );
};
